<template>
  <div
    data-testid="header-static"
    ref="container"
    class="relative flex min-h-96 flex-col overflow-hidden bg-cover bg-top lg:h-[28rem]"
    :style="{
      'background-image': `linear-gradient(rgba(50, 50, 100, 0.3), rgba(50, 50, 100, 0.3)), ${backgroundImage}`,
    }"
  >
    <ngp-toggle />
    <header-server-name :scrolled="false" class="pt-12" />
    <header-server-details
      class="from-gp-midnight-gradient-a/60 to-gp-midnight-gradient-b/60 bg-linear-to-b px-4 py-5"
    />
  </div>
</template>

<script setup lang="ts">
import { useElementBounding } from "@vueuse/core";
import { computed, ref, watchEffect } from "vue";
import { useServiceStore } from "../../store/service";
import NgpToggle from "../util/NgpToggle.vue";
import HeaderServerDetails from "./HeaderServerDetails.vue";
import HeaderServerName from "./HeaderServerName.vue";
import { headerStaticHeight } from "./height";

const service = useServiceStore();

const game = computed(() => service.ctx.sys?.game);

const container = ref();
const { height } = useElementBounding(container);

watchEffect(() => {
  headerStaticHeight.value = height.value;
});

const backgroundImage = computed(() =>
  game.value?.key ? `url('https://cdn.g-portal.com/images/games/${game.value.key}/header_cover.jpg')` : undefined,
);
</script>
